const GarLogPerformanceConstants = {
  LOAD_START: "garLogPerformance/LOAD_START",
  CHECK_STEP_PROPERTIES: "garLogPerformance/CHECK_STEP_PROPERTIES_LOAD",
  SET_STEP_PROPERTIES: "garLogPerformance/SET_STEP_PROPERTIES_LOAD",
  CHECK_PLAN_SUMMARY: "garLogPerformance/CHECK_PLAN_SUMMARY_LOAD",
  SET_PLAN_SUMMARY: "garLogPerformance/SET_PLAN_SUMMARY_LOAD",
  CHECK_AUTOSHUTDOWN: "garLogPerformance/CHECK_AUTOSHUTDOWN_LOAD",
  SET_AUTOSHUTDOWN: "garLogPerformance/SET_AUTOSHUTDOWN_LOAD",
  CHECK_ALERTS: "garLogPerformance/CHECK_ALERTS_LOAD",
  SET_ALERTS: "garLogPerformance/SET_ALERTS_LOAD",
  CHECK_EXPERIMENT_INFO: "garLogPerformance/CHECK_EXPERIMENT_INFO_LOAD",
  SET_EXPERIMENT_INFO: "garLogPerformance/SET_EXPERIMENT_INFO_LOAD",
  CHECK_ANALYSES: "garLogPerformance/CHECK_ANALYSES_LOAD",
  SET_ANALYSES: "garLogPerformance/SET_ANALYSES_LOAD",
  CHECK_SCORECARDS: "garLogPerformance/CHECK_SCORECARDS_LOAD",
  SET_SCORECARDS: "garLogPerformance/SET_SCORECARDS_LOAD",
  CHECK_HYPOTHESIS: "garLogPerformance/CHECK_HYPOTHESIS_LOAD",
  SET_HYPOTHESIS: "garLogPerformance/SET_HYPOTHESIS_LOAD",
  CHECK_SLICES: "garLogPerformance/CHECK_SLICES_LOAD",
  SET_SLICES: "garLogPerformance/SET_SLICES_LOAD",
  CHECK_WARNINGS: "garLogPerformance/CHECK_WARNINGS_LOAD",
  SET_WARNINGS: "garLogPerformance/SET_WARNINGS_LOAD",
  CHECK_METRIC_CATEGORIES: "garLogPerformance/CHECK_METRIC_CATEGORIES_LOAD",
  SET_METRIC_CATEGORIES: "garLogPerformance/SET_METRIC_CATEGORIES_LOAD",
  CHECK_SCORECARD_DATA: "garLogPerformance/CHECK_SCORECARD_DATA_LOAD",
  SET_SCORECARD_DATA: "garLogPerformance/SET_SCORECARD_DATA_LOAD",
  CHECK_SCORECARD_INSIGHTS: "garLogPerformance/CHECK_SCORECARD_INSIGHTS_LOAD",
  SET_SCORECARD_INSIGHTS: "garLogPerformance/SET_SCORECARD_INSIGHTS_LOAD",
  MAIN_FUNCTIONALITY: "garLogPerformance/MAIN_FUNCTIONALITY",
  MAIN_FUNCTIONALITY_LOAD: "garLogPerformance/MAIN_FUNCTIONALITY_LOAD",
  FULL_LOAD: "garLogPerformance/FULL_LOAD",
  NO_LOAD_PLACEHOLDER: -1
};
export {
  GarLogPerformanceConstants as default
};
//# sourceMappingURL=GarLogPerformanceConstants.js.map
